module.exports = __webpack_public_path__ + "static/media/Maf_error404.9e973100.png";